import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../services/i18n/i18nSlice"

import exam_img from './assets/images/exam.svg'
import clock_img from './assets/images/clock.svg'
import structure_img from './assets/images/structure.svg'
import { Link } from "react-router-dom"
import { TitleH3 } from "../../components/TitleH3"
import ExamsList from "./ExamList"

import './assets/Exam.css'
import { useEffect } from "react"
import { setLoading, setNavbarHide, setNavbarHideMobile } from "../../services/global/globalSlice"
import { TitleH1 } from "../../components/TitleH1"
import { selectAppInfo } from "../../services/utils/appInfoSlice"
import { loadUserProfileData } from "../../features/User/userSlice"
import DesktopSheet from "../../components/_ofa_component/DesktopSheet"
import { loadCurrentNotificationDebounced } from "../../features/Notification/notificationSlice"

export default function ExamsScreen () {

    const t = useSelector(selectTranslations)
    const appInfo = useSelector(selectAppInfo)
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(setNavbarHideMobile(false))
        dispatch(setNavbarHide(false))
        dispatch(setLoading(false))
        if(appInfo.is_ofa)
            dispatch(loadUserProfileData())
        if(appInfo?.personalizations?.enabled_sections?.notifications)
            dispatch(loadCurrentNotificationDebounced()) 
    },[])

    return (
        <section className="content_section">
            <TitleH1 className="page_title">{appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.page_title : t.exams.page_title}</TitleH1>
            <div className="navigation_chips__container mt-4">
                <div className="navigation_chip active">
                    <img src={exam_img} alt="" />
                    {appInfo?.personalizations?.tenant_settings?.is_self_assessment ? t.self_assessment_test.alternative_copy.all_exams : t.exams.all_exams}
                </div>
                <Link to={'/exams/customizable'}>
                    <div className="navigation_chip">
                        <img src={structure_img} alt="" />
                        {t.exams.customizable_exams}
                    </div>
                </Link>
                <Link to={'/exams/history'}>
                    <div className="navigation_chip">
                        <img src={clock_img} alt="" />
                        {t.exams.exams_history}
                    </div>
                </Link>
            </div> 
            <div className="mt-4">
                <div className=" mt-3">
                    <ExamsList title={t.exams.available_exams} showPending={true} showStarted={true}/>
                </div>
            </div>
            <div className="mt-5">
                <div className=" mt-3">
                    <ExamsList title={t.exams.future_exams} showPending={false} showStarted={false}/>
                </div>
            </div>
            {
                (appInfo.is_ofa || appInfo.is_linked_to_app) && 
                    <DesktopSheet />
            }
        </section>
        
    )
}